import { t } from '../utilities/lang';

export const PHONE_TOOLTIP_TEXT = t('text.phone_tooltip');

export const PHONE_ERROR_MESSAGE = t('text.phone_error');

export const AUDIENCE_CREATION_DESC = t('text.audience_creation_desc');
